import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Zendesk Update Ticket v1 Configuration Validator
 * Validates Zendesk ticket update configuration
 */
export const Zendesk_Update_Ticket_1_ConfigValidator = z.object({
    zendeskConnection: requiredString('Zendesk Connection is required'),
    ticketId: requiredString('Ticket ID is required'),
    subject: z.string().optional(),
    description: z.string().optional(),
    requesterName: z.string().optional(),
    requesterEmail: z.string().optional(),
    status: z.enum(['new', 'open', 'pending', 'hold', 'solved', 'closed']).nullable().optional(),
    priority: z.enum(['low', 'normal', 'high', 'urgent']).nullable().optional(),
    assigneeId: z.string().optional(),
    groupId: z.string().optional(),
    brandId: z.string().optional(),
    ticketFormId: z.string().optional(),
    customFields: z.record(z.string(), z.any()).optional()
});
//# sourceMappingURL=zendesk-update-ticket-1.js.map